import { useEffect } from 'react'
import { WebsocketEvent } from 'entities/WebSocket'
import { useEntitiesContext } from 'entities/EntitiesExport'
import type { ContactsSurveysStore } from '../store/ContactsSurveysStore'

export const useEventContactSurveyExecutionCreated = (store: ContactsSurveysStore) => {
  const { websocket } = useEntitiesContext()

  useEffect(
    () => websocket.on(WebsocketEvent.ContactSurveyExecutionCreated, store.addCreatedExecution),
    []
  )
}
